import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { TreeProgramTopHeader } from 'components/common';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSummary } from 'components/widgets/VersionSummary/VersionSummary';
import { InputPrograms } from 'components/widgets/InputPrograms/InputPrograms';
import { CrossProgramRelationships } from 'components/widgets/CrossProgramRelationships/CrossProgramRelationships';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { Route, useRouteMatch } from 'react-router-dom';
import { MainCard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

export const IntegratedProgramDetailsPage = () => {
    const { path } = useRouteMatch();
    useFullStoryPageView({ pageName: projectConfig.integratedProgramDetails.title });
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader
                            versionSelectorEnabled={false}
                            pageTitle={projectConfig.integratedProgramDetails.title}
                            showAll={true}
                            showBack={true}
                            isDisabled={true}
                            showBackLink={AppRoutes.buildPath(
                                AppRoutes.DASHBOARD_PROJECT_PATH,
                                projectConfig.programLibrary.link,
                            )}
                        />
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>
            <MainContent>
                <VersionSummary />
                <InputPrograms />
                <CrossProgramRelationships />
            </MainContent>
            <Route path={`${path}/card-:cardId`} render={() => <MainCard />} />
        </PageContainer>
    );
};
